<template>
  <div data-v-e5781868="" class="app-wrapper">
    <div data-v-e5781868="" class="leftSliderBarWrap">
      <div data-v-7ad90110="" data-v-e5781868="" class="leftSliderBar" style="background: #fff;">
        <a data-v-7ad90110="" class="toggle"
          ><span data-v-7ad90110="" class="close"
            ><svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon closeSidebar">
              <use data-v-338e1447="" xlink:href="#icon-closeSidebar"></use></svg></span
          ><span data-v-7ad90110="" class="open"
            ><svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon openSidebar">
              <use data-v-338e1447="" xlink:href="#icon-openSidebar"></use></svg></span
        ></a>
        <div data-v-7ad90110="" class="defaultState">
          <div data-v-7ad90110="" class="top" @click="goNav('/')" style="cursor: pointer;background: #fff;">
			<img data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" src="/static/style/pop-logo.52e439b0.png" alt="logo" class="svg-icon logo" />  
          </div>
          <div data-v-7ad90110="" class="c">
            <div data-v-7ad90110="" class="navigation">
              <ul data-v-7ad90110="" class="group1">
                <a href="javascript:void(0);" @click="goNav('/')">
                  <li data-v-7ad90110="" :class="path == '/' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconHome">
                      <use data-v-338e1447="" xlink:href="#icon-iconHome"></use>
                    </svg>
                    <h3 data-v-7ad90110="">首页</h3>
                  </li>
                </a>
                <a href="javascript:void(0);" @click="goNav('/realPerson')">
                  <li data-v-7ad90110="" :class="path == '/realPerson' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconLive">
                      <use data-v-338e1447="" xlink:href="#icon-iconLive"></use>
                    </svg>
                    <h3 data-v-7ad90110="">真人</h3>
                  </li>
                </a>
                <a href="javascript:void(0);" @click="goNav('/electronics')">
                  <li data-v-7ad90110="" :class="path == '/electronics' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconGames">
                      <use data-v-338e1447="" xlink:href="#icon-iconGames"></use>
                    </svg>
                    <h3 data-v-7ad90110="">电游</h3>
                  </li>
                </a>
                <a href="javascript:void(0);" @click="goNav('/sports')">
                  <li data-v-7ad90110="" :class="path == '/sports' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconSports">
                      <use data-v-338e1447="" xlink:href="#icon-iconSports"></use>
                    </svg>
                    <h3 data-v-7ad90110="">体育</h3>
                  </li>
                </a>
                <a href="javascript:void(0);" @click="goNav('/eSports')">
                  <li data-v-7ad90110="" :class="path == '/eSports' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconGames">
                      <use data-v-338e1447="" xlink:href="#icon-iconGames"></use>
                    </svg>
                    <h3 data-v-7ad90110="">电竞</h3>
                  </li>
                </a>
                <a href="javascript:void(0);" @click="goNav('/lottery')">
                  <li data-v-7ad90110="" :class="path == '/lottery' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconLottery">
                      <use data-v-338e1447="" xlink:href="#icon-iconLottery"></use>
                    </svg>
                    <h3 data-v-7ad90110="">彩票</h3>
                  </li>
                </a>
                <a href="javascript:void(0);" @click="goNav('/cards')">
                  <li data-v-7ad90110="" :class="path == '/cards' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconCards">
                      <use data-v-338e1447="" xlink:href="#icon-iconCards"></use>
                    </svg>
                    <h3 data-v-7ad90110="">棋牌</h3>
                  </li>
                </a>
              </ul>
              <div data-v-7ad90110="" class="separator"></div>
              <ul data-v-7ad90110="">
                <li data-v-7ad90110="" :class="path == '/discount' ? 'active' : ''">
                  <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconGifts">
                    <use data-v-338e1447="" xlink:href="#icon-iconGifts"></use>
                  </svg>
                  <a href="javascript:void(0);" @click="goNav('/discount')">
                    <h3 data-v-7ad90110="">最新优惠</h3>
                  </a>
                </li>
              </ul>
              <div data-v-7ad90110="" class="group" style="display: ">
                <div data-v-7ad90110="" class="separator"></div>
                <ul data-v-7ad90110="">
                  <a href="javascript:void(0);">
                    <li data-v-7ad90110="" :class="path == '/accountSetting' ? 'active' : ''" @click="goNav('/accountSetting')">
                      <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconUser">
                        <use data-v-338e1447="" xlink:href="#icon-iconUser"></use>
                      </svg>
                      <h3 data-v-7ad90110="">会员中心</h3>
                    </li>
                    <li data-v-7ad90110="" class="" @click="getAgentLoginUrl">
                      <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconStar">
                        <use data-v-338e1447="" xlink:href="#icon-iconStar"></use>
                      </svg>
                      <h3 data-v-7ad90110="">代理登录</h3>
                    </li>
                    <li data-v-7ad90110="" :class="path == '/vip' ? 'active' : ''" @click="goNav('/vip')">
                      <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconVip">
                        <use data-v-338e1447="" xlink:href="#icon-iconVip"></use>
                      </svg>
                      <h3 data-v-7ad90110="">VIP俱乐部</h3>
                    </li>
                  </a>
                </ul>
              
              </div>
            </div>
            <div data-v-7ad90110="" class="qrBox">
              <div data-v-7ad90110="" class="qr">
                <div data-v-7ad90110="" class="qr-img" :title="$store.state.appInfo.ios_download_url">
                  <img alt="Scan me!" :src="$store.state.appInfo.ios_download_qrcode" style="display: block; width: 100%" />
                </div>
              </div>
              <p data-v-7ad90110="">扫码下载{{ $store.state.appInfo.title }}APP</p>
            </div>
          </div>
        </div>
        <div data-v-7ad90110="" class="minState">
          <div data-v-7ad90110="" class="top">
			<img data-v-338e1447="" data-v-7ad90110="" src="/static/style/minilogo.png" alt="nav logo" class="svg-icon logo2"/>  
          </div>
          <div data-v-7ad90110="" class="c">
            <div data-v-7ad90110="" class="navigation">
              <ul data-v-7ad90110="" class="group1">
                <a @click="goNav('/')" href="javascript:void(0);">
                  <li data-v-7ad90110="" :class="path == '/' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconHome">
                      <use data-v-338e1447="" xlink:href="#icon-iconHome"></use></svg
                    ><span data-v-7ad90110="" class="title">首页</span>
                  </li>
                </a>
                <a @click="goNav('/realPerson')" href="javascript:void(0);">
                  <li data-v-7ad90110="" :class="path == '/realPerson' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconLive">
                      <use data-v-338e1447="" xlink:href="#icon-iconLive"></use></svg
                    ><span data-v-7ad90110="" class="title">真人</span>
                  </li>
                </a>
                <a href="javascript:void(0);" @click="goNav('/electronics')">
                  <li data-v-7ad90110="" :class="path == '/electronics' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconGames">
                      <use data-v-338e1447="" xlink:href="#icon-iconGames"></use></svg
                    ><span data-v-7ad90110="" class="title">电游</span>
                  </li>
                </a>
                <a href="javascript:void(0);" @click="goNav('/sports')">
                  <li data-v-7ad90110="" :class="path == '/sports' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconSports">
                      <use data-v-338e1447="" xlink:href="#icon-iconSports"></use></svg
                    ><span data-v-7ad90110="" class="title">体育</span>
                  </li>
                </a>
                <a href="javascript:void(0);" @click="goNav('/lottery')">
                  <li data-v-7ad90110="" :class="path == '/lottery' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconLottery">
                      <use data-v-338e1447="" xlink:href="#icon-iconLottery"></use></svg
                    ><span data-v-7ad90110="" class="title">彩票</span>
                  </li>
                </a>
                <a href="javascript:void(0);" @click="goNav('/cards')">
                  <li data-v-7ad90110="" :class="path == '/cards' ? 'active' : ''">
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconCards">
                      <use data-v-338e1447="" xlink:href="#icon-iconCards"></use></svg
                    ><span data-v-7ad90110="" class="title">棋牌</span>
                  </li>
                </a>
              </ul>
              <div data-v-7ad90110="" class="separator"></div>
              <ul data-v-7ad90110="">
                <a href="javascript:void(0);" @click="goNav('/discount')">
                  <li data-v-7ad90110="" :class="path == '/discount' ? 'active' : ''" >
                    <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconGifts">
                      <use data-v-338e1447="" xlink:href="#icon-iconGifts" ></use>
                    </svg>
                    <span data-v-7ad90110="" class="title">最新优惠</span>
                  </li>
                </a>
              </ul>
              <div data-v-7ad90110="" class="group" style="display: ">
                <div data-v-7ad90110="" class="separator"></div>
                <ul data-v-7ad90110="">
                  <a href="javascript:void(0);">
                    <li data-v-7ad90110="" :class="path == '/accountSetting' ? 'active' : ''">
                      <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconUser" @click="goNav('/accountSetting')">
                        <use data-v-338e1447="" xlink:href="#icon-iconUser"></use></svg
                      ><span data-v-7ad90110="" class="title">会员中心</span>
                    </li>

                    <div data-v-7ad90110="" @click="getAgentLoginUrl" class="box box2">
                      <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon iconStar">
                        <use data-v-338e1447="" xlink:href="#icon-iconStar"></use></svg
                      ><span data-v-7ad90110="" class="title">代理登录</span>
                    </div>
                    <li data-v-7ad90110="" :class="path == '/vip' ? 'active' : ''" @click="goNav('/vip')">
                      <svg data-v-338e1447="" data-v-7ad90110="" aria-hidden="true" class="svg-icon icon iconVip">
                        <use data-v-338e1447="" xlink:href="#icon-iconVip"></use></svg
                      ><span data-v-7ad90110="" class="title">VIP俱乐部</span>
                    </li>
                  </a>
                </ul>
              </div>
            </div>
            <div data-v-7ad90110="" class="qrBox">
              <div data-v-7ad90110="" class="qr"><img data-v-7ad90110="" src="/static/image/qr2.e81f9008.jpg" /></div>
              <div data-v-7ad90110="" class="qrBoxWarp">
                <div data-v-7ad90110="" class="qr-img" :title="$store.state.appInfo.ios_download_url">
                  <img alt="Scan me!" :src="$store.state.appInfo.ios_download_qrcode" style="display: block; width: 100%" />
                </div>
                <p data-v-7ad90110="">扫码下载{{ $store.state.appInfo.title }}APP</p>
              </div>
            </div>
          </div>
        </div>
        <div data-v-7ad90110="" class="user-level">0/0</div>
      </div>
    </div>
    <div data-v-e5781868="" class="mainContentWrap leftSliderOpen">
      <Header />

      <router-view />
      <div data-v-5abf1f28="" data-v-011e1fb8="" id="homeFooter" class="footer">
        <div data-v-5abf1f28="" class="fixed-bottom">
          <div data-v-05425edc="" data-v-5abf1f28="" class="stockDividendPendant min" style="display: none">
            <div data-v-05425edc="" class="stockDividendPendant_txt"><span data-v-05425edc="" class="stockDividendPendant_txt_num"></span>时<span data-v-05425edc="" class="stockDividendPendant_txt_num"></span>分<span data-v-05425edc="" class="stockDividendPendant_txt_num"></span>秒<!----></div>
          </div>
          <div data-v-5abf1f28="" class="clear"></div>
          <div data-v-5abf1f28="" class="clearfix"></div>
          <div data-v-5abf1f28="" class="clear"></div>
          <div data-v-5abf1f28="" class="tool">
            <a data-v-5abf1f28="" class="btn-min btm-icons" @click="openKefu()"
              ><svg data-v-338e1447="" data-v-5abf1f28="" aria-hidden="true" class="svg-icon cs"><use data-v-338e1447="" xlink:href="#icon-cs"></use></svg></a
            ><!---->
            <div data-v-5abf1f28="" class="clear"></div>
          </div>
        </div>
      </div>
      <Foot />
    </div>

    <AllLogin />
    <div data-v-3e52ce59="" class="loading" v-if="loading">
      <div data-v-3e52ce59="" class="loader"><span data-v-3e52ce59="" class="load-img"></span></div>
    </div>
  </div>
</template>

<script>
import Header from './libs/Header';
import Foot from './libs/Foot';
import AllLogin from './libs/allLogin';
export default {
  name: 'Main',
  data() {
    return { path: '/', loading: false };
  },
  components: {
    Header,
    Foot,
    AllLogin,
  },
  created() {
    let that = this;
  },
  updated() {},
  mounted() {
    jQuery('.marquee').slide({ mainCell: '.marquee-box ul', autoPage: true, effect: 'topLoop', autoPlay: true, vis: 4, mouseOverStop: false, delayTime: 700 });
    $('.leftSliderBar .toggle').click(function () {
      $(this).parent('.leftSliderBar').toggleClass('leftSliderMinBar');
      $(this).parent('.leftSliderBar').parent('.leftSliderBarWrap').toggleClass('min');
      $(this).parent('.leftSliderBar').parent('.leftSliderBarWrap').next('.mainContentWrap').toggleClass('leftSliderOpen').toggleClass('leftSliderMin');
    });
  },
  methods: {
    getAgentLoginUrl() {
      let that = this;
      that.showTost(1, '正在前往页面');
      let pathInfo = this.$router.resolve({
        path: '/gamePage',
        query: {
          dailiD: 1,
        },
      });
      window.open(pathInfo.href, '_blank');
    },
    openDaoTime() {
      this.$parent.openDaoTime();
    },
    closeDaoTime() {
      this.$parent.closeDaoTime();
    },
    getUserInfoShowLoding() {
      this.$parent.getUserInfoShowLoding();
    },
    goGamePage(name, type, code) {
      let that = this;
      that.showLoading();
      type = type == null ? 0 : type;
      that.$apiFun
        .post('/api/getGameUrl', { plat_name: name, game_type: type, game_code: code, is_mobile_url: 0 })
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.hideLoading();
            window.open(res.data.url, '_self');
          }
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    openGamePage(name, type, code) {
      let that = this;
      type = type == null ? 0 : type;

      let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
      if (!token) {
        that.showTost(0, '请登录！');
        $('.mask').fadeOut(300);
        $('.mask.login').fadeIn(300);
        return;
      }

      that.showTost(1, '正在前往打开游戏页面');
      let pathInfo = this.$router.resolve({
        path: '/gamePage',
        query: {
          name,
          type,
          code,
        },
      });
      window.open(pathInfo.href, '_blank');
    },
    showLoading() {
      this.loading = true;
    },
    hideLoading() {
      this.loading = false;
    },
    goNav(url) {
      let that = this;
      if (url == '/userredpacket') {
        if (!that.$store.state.token) {
          that.showTost(0, '请登录！');
          return;
        }
        let routerData = this.$router.resolve({
          path: `/userredpacket`,
        });
        window.open(routerData.href, '_blank');
        return;
      }
      if (url == this.$route.fullPath) {
        if (url == '/') {
          return;
        }
        that.showTost(0, '已在当前页面！');
        return;
      }
      this.url = url;
      if (url == '/accountSetting') {
        if (!sessionStorage.getItem('token')) {
          $('.mask').fadeOut(300);
          $('.mask.login').fadeIn(300);
          return;
        }
      }
      this.$router.push({ path: url });
    },
    openKefu() {
      let that = this;
      that.showTost(1, '正在链接人工客服');
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          window.open(res.data.url);
        }
      });
    },
    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        if (res.code === 200) {
          that.userInfo = res.data;
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
      });
    },
    showTost(type, title) {
      // error  success
      let str = type ? 'success' : 'error';
      $('body').append(`
            <div role="alert" class="ants-message el-message el-message--${str}" style="top: 20px; z-index: 2009;"><i class="el-message__icon el-icon-${str}"></i>
            <p class="el-message__content">${title}
            </p></div>`);
      setTimeout('$(".ants-message").detach()', 2000);
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        let that = this;
        that.path = this.$route.path;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.app-wrapper {
  width: 100%;
  background-color: #ffffff;
  color: #333333;
}

// 侧边栏样式调整
.leftSliderBarWrap {
  background-color: #f8f9fa;
  border-right: 1px solid #e0e0e0;
}

.leftSliderBar {
  color: #5a5a5a; /* 将默认颜色调整为深灰色，比纯黑更柔和 */
  
  .toggle {
    color: #666666;
    
    // 修复切换按钮颜色
    .close, .open {
      .svg-icon {
        color: #5a5a5a !important;
        fill: #5a5a5a !important;
      }
    }
  }
  
  .navigation {
    ul {
      li {
        color: #5a5a5a; /* 分类项文字颜色 - 深灰色 */
        
        &.active {
          background-color: #e6f7ff; /* 激活状态背景色 - 淡蓝色 */
          color: #1890ff; /* 激活状态文字颜色 - 蓝色 */
        }
        
        &:hover {
          background-color: #f0f7ff; /* 悬停状态背景色 - 更淡的蓝色 */
          color: #1890ff; /* 悬停状态文字颜色 - 蓝色 */
          transition: all 0.3s ease; /* 平滑过渡效果 */
        }
        
        h3, .title {
          color: inherit; /* 继承父元素颜色 */
        }
      }
    }
    
    .separator {
      background-color: #e0e0e0;
    }
  }
  
  .qrBox {
    p {
      color: #555555;
    }
  }
  
  .user-level {
    color: #666666;
  }
  
  // 缩小状态样式
  &.leftSliderMinBar {
    .minState {
      // 修复缩小状态下的LOGO颜色
      .top .logo2 {
        color: #666 !important;
        fill: #5a5a5a !important;
      }
      
      .navigation {
        .title {
		  background:#f0f7ff ;	
          color: #5a5a5a !important;
          fill: #5a5a5a !important;
        }
      }
    }
  }
  
  // 修复缩小状态下的样式问题
  .minState {
    // 修复缩小状态下的LOGO颜色
    .top .logo2 {
      color: #5a5a5a !important;
      fill: #5a5a5a !important;
    }
    
    .title {
      color: #5a5a5a !important;
    }
    
    .box.box2 {
      background-color: transparent !important;
      color: #5a5a5a;
      
      .svg-icon {
        color: #5a5a5a;
      }
    }
  }
  
  // 修复正常状态下的LOGO颜色
  .defaultState {
    .top .logo {
      color: #5a5a5a !important;
      fill: #5a5a5a !important;
    }
  }
}

// 穿透scoped限制，确保样式生效
::v-deep .leftSliderBar .toggle .svg-icon {
  color: #5a5a5a !important;
  fill: #5a5a5a !important;
}

::v-deep .leftSliderBar .top .svg-icon.logo,
::v-deep .leftSliderBar .top .svg-icon.logo2 {
  color: #5a5a5a !important;
  fill: #5a5a5a !important;
}

// 特别针对最新优惠等分类项的样式优化
::v-deep .leftSliderBar .navigation ul li {
  h3, .title {
    font-weight: 500; /* 略微加粗文字 */
  }
}

// 主内容区域样式
.mainContentWrap {
  background-color: #ffffff;
  
  * {
    color: #333333;
  }
}

// 页脚样式调整
.footer[data-v-5abf1f28] {
  position: relative;
  background: #f8f9fa;
  background-image: -webkit-gradient(linear, left top, left bottom, from(#f8f9fa), to(#e9ecef));
  background-image: linear-gradient(180deg, #f8f9fa, #e9ecef);
  -webkit-filter: none;
  filter: none;
  color: #555555;
}

.footer .fixed-bottom[data-v-5abf1f28] {
  position: fixed;
  right: 0.2rem;
  bottom: 1rem;
  z-index: 98;
}

.stockDividendPendant.min[data-v-05425edc] {
  width: 40px;
  height: 40px;
}

.min[data-v-5abf1f28] {
  width: 0.44rem;
  height: 0.44rem;
}

.stockDividendPendant[data-v-05425edc] {
  position: relative;
  width: 120px;
  height: 120px;
  font-size: 12px;
  color: #555555;
  cursor: pointer;
}

.clearfix {
  zoom: 1;
}

.footer .fixed-bottom .tool .btn-min[data-v-5abf1f28] {
  display: block;
  float: right;
  width: 0.44rem;
  height: 0.44rem;
  margin-bottom: 0.1rem;
  text-align: center;
  cursor: pointer;
  background-position: -0.42rem -0.38rem;
  background-color: #e0e0e0;
  border-radius: 50%;
  color: #333333;
}

.footer .fixed-bottom .tool .btn-min .cs[data-v-5abf1f28] {
  width: 0.44rem;
  height: 0.44rem;
}

.svg-icon[data-v-338e1447] {
  width: 10em;
  height: 10em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.footer .fixed-bottom {
  bottom: 3rem !important;
}

// 加载动画样式
.loading[data-v-3e52ce59] {
  background-color: rgba(255, 255, 255, 0.8);
  
  .loader {
    border: 3px solid #f3f3f3;
    border-top: 3px solid #3498db;
  }
}

// 提示框样式
.ants-message {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  
  .el-message__content {
    color: #333333;
  }
}

.el-message--success {
  .el-icon-success {
    color: #28a745;
  }
}

.el-message--error {
  .el-icon-error {
    color: #dc3545;
  }
}
.leftSliderBar .minState .qrBox:hover .qrBoxWarp[data-v-7ad90110]{
	background: #e0e0e0;
}
.leftSliderBar .minState .qrBox:hover .qrBoxWarp .before[data-v-7ad90110] {

  color: #ccc !important;

}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue